import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const ErrorPopUp = (props) => {
  const { message, resetMessage, openError, setOpenError } = props;

  const handleOk = () => {
    setOpenError(false);
    resetMessage('');
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={openError}>
      <DialogContent dividers>
        <Typography variant='h6'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorPopUp;
